export const TableSorter = ({ column, sortBy, descending, setSortBy, setDescending, children }) => {
    const click = () => {
        setDescending(column === sortBy ? !descending : false);
        setSortBy(column);
    };

    return (
        <div className="flex flex-center pointer no-wrap" data-testid="table-sorter">
            <button className="btn btn-link" onClick={click}>
                <span>{children}</span>
                <span className="no-wrap" style={{ visibility: column !== sortBy ? 'hidden' : '' }}>
                    <i className={`fa fa-caret-${descending ? 'down' : 'up'}`} />
                </span>
            </button>
        </div>
    );
};

export default TableSorter;
